import client from './main-client';

export const getLoanTypesApi = (params) => client()
  .get('/options-loan-types', { params });
